import firebase from 'firebase';

var config = {
    apiKey: "AIzaSyATad9mdS85bZPesVOnJpSP3BSwVAg60aY",
    authDomain: "taksy-bacer.firebaseapp.com",
    projectId: "taksy-bacer",
    databaseURL: "https://taksy-bacer.firebaseio.com/",
    //databaseURL: "https://taksy-bacer-develop.firebaseio.com/",
    storageBucket: "taksy-bacer.appspot.com",
    messagingSenderId: "368668879750"
};

const secondaryApp = firebase.initializeApp(config, "Secondary");

export default secondaryApp;


// WEBPACK FOOTER //
// ./src/Components/BD/secondaryApp.js